import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build(
	"/admin/search/requests/:searchId/details/user/:userId",
	lazy(() => import("./AdminSearchesDetailsPage"))
);
